module.exports = __webpack_public_path__ + "media/images/icon_venn_active-061651bb7c58fddb8e2ec4b058fc1bb0.svg";